import {
  SliderProps as MantineSliderProps,
  Slider as MantineSlider,
} from '@mantine/core';

export type SliderProps = MantineSliderProps;

export const Slider = MantineSlider;

Slider.displayName = 'Slider';
